module.exports = __webpack_public_path__ + "img/objective-2.b2498388.jpg";